const KEY = "keepthis_attribution";
const PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid", "gclid"];

// First-touch campaign params for this visit (kept in sessionStorage only).
export const captureAttribution = () => {
  try {
    if (window.sessionStorage.getItem(KEY)) return;
    const q = new URLSearchParams(window.location.search);
    const data = { landing_path: window.location.pathname.slice(0, 300) };
    PARAMS.forEach((p) => {
      const v = q.get(p);
      if (v) data[p] = v.slice(0, p.endsWith("clid") ? 500 : 200);
    });
    window.sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    /* storage unavailable */
  }
};

export const getAttribution = () => {
  try {
    return JSON.parse(window.sessionStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
};
